import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorklogFilter } from '../_models/filters/worklog-filter';
import { WorklogsOverview } from '../_models/worklogs-overview';

@Injectable()
export class WorklogsService {
  constructor(private http: HttpClient) {}

  getFiltered(filter: WorklogFilter): Observable<WorklogsOverview> {
    return this.http.get<WorklogsOverview>(`/api/worklogs`, {params: filter.toParams()});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`/api/worklogs/${id}`);
  }

  add(worklog: any): Observable<void> {
    return this.http.post<void>('/api/worklogs', worklog);
  }
}
